/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Honors_Title_AccentInputs */

const en_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`industry recognition`)
};

const es_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reconocimiento del sector`)
};

const de_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anerkennung in der Branche`)
};

const zh_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行业认可`)
};

const ar_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقدير في المجال`)
};

const fr_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reconnaissance du secteur`)
};

const vi_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sự công nhận trong ngành`)
};

const sw_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kutambuliwa katika tasnia`)
};

const th_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การยอมรับในวงการ`)
};

const bs_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`priznanja u struci`)
};

const ja_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`業界からの評価`)
};

const ko_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업계의 인정`)
};

const pt_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reconhecimento do setor`)
};

const it_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`riconoscimento del settore`)
};

const sv_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erkännande i branschen`)
};

const nl_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erkenning uit de golfbranche`)
};

const da_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anerkendelse i branchen`)
};

const nb_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anerkjennelse i bransjen`)
};

const fi_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alan tunnustukset`)
};

const pl_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uznanie w branży`)
};

const ru_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`отраслевое признание`)
};

const tr_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sektörde tanınırlık`)
};

const hi_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उद्योग में मान्यता`)
};

const id_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pengakuan industri`)
};

const ms_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pengiktirafan industri`)
};

const cs_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uznání v oboru`)
};

const el_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`αναγνώριση στον κλάδο`)
};

const he_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכרה בענף`)
};

const af_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erkenning in die bedryf`)
};

const hu_about_honors_title_accent = /** @type {(inputs: About_Honors_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`szakmai elismerések`)
};

/**
* | output |
* | --- |
* | "industry recognition" |
*
* @param {About_Honors_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_honors_title_accent = /** @type {((inputs?: About_Honors_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Honors_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_honors_title_accent(inputs)
	if (locale === "de") return de_about_honors_title_accent(inputs)
	if (locale === "zh") return zh_about_honors_title_accent(inputs)
	if (locale === "ar") return ar_about_honors_title_accent(inputs)
	if (locale === "fr") return fr_about_honors_title_accent(inputs)
	if (locale === "vi") return vi_about_honors_title_accent(inputs)
	if (locale === "sw") return sw_about_honors_title_accent(inputs)
	if (locale === "th") return th_about_honors_title_accent(inputs)
	if (locale === "bs") return bs_about_honors_title_accent(inputs)
	if (locale === "ja") return ja_about_honors_title_accent(inputs)
	if (locale === "ko") return ko_about_honors_title_accent(inputs)
	if (locale === "pt") return pt_about_honors_title_accent(inputs)
	if (locale === "it") return it_about_honors_title_accent(inputs)
	if (locale === "sv") return sv_about_honors_title_accent(inputs)
	if (locale === "nl") return nl_about_honors_title_accent(inputs)
	if (locale === "da") return da_about_honors_title_accent(inputs)
	if (locale === "nb") return nb_about_honors_title_accent(inputs)
	if (locale === "fi") return fi_about_honors_title_accent(inputs)
	if (locale === "pl") return pl_about_honors_title_accent(inputs)
	if (locale === "ru") return ru_about_honors_title_accent(inputs)
	if (locale === "tr") return tr_about_honors_title_accent(inputs)
	if (locale === "hi") return hi_about_honors_title_accent(inputs)
	if (locale === "id") return id_about_honors_title_accent(inputs)
	if (locale === "ms") return ms_about_honors_title_accent(inputs)
	if (locale === "cs") return cs_about_honors_title_accent(inputs)
	if (locale === "el") return el_about_honors_title_accent(inputs)
	if (locale === "he") return he_about_honors_title_accent(inputs)
	if (locale === "af") return af_about_honors_title_accent(inputs)
	if (locale === "hu") return hu_about_honors_title_accent(inputs)
	return en_about_honors_title_accent(inputs)
});